import { IPlan, ITask } from "../../../common/types";

export default {
    homework: {
        _id: "5e6defd6546468500220040b",
        user: "5b2504ca09ddd4002a1d40f3",
        title: "Teszt feladat",
        planId: "5e4d94c74f8087001e343133",
        date: 1584435600000,
        classId: "5ceef34541c015001702b3a4",
        __v: 0,
        className: "4/b",
    },
    results: [
        {
            result: [{ time: 20, play: 0, fail: 0, gaveUp: false }, { time: 30, play: 0, fail: 0, gaveUp: false }],
            name: "Laci",
            studentId: "1",
            date: 1,
        },
        {
            result: [{ time: 40, play: 0, fail: 0, gaveUp: false }, { time: 20, play: 0, fail: 0, gaveUp: false }],
            name: "Hanna",
            studentId: "2",
            date: 1,
        },
        {
            result: [{ time: 120, play: 0, fail: 0, gaveUp: false }, { time: 40, play: 0, fail: 0, gaveUp: false }],
            name: "Joci",
            studentId: "3",
            date: 1,
        },
        {
            result: [{ time: 100, play: 0, fail: 0, gaveUp: false }, { time: 100, play: 0, fail: 0, gaveUp: false }],
            name: "Zoé",
            studentId: "4",
            date: 1,
        },
        {
            result: [{ time: 40, play: 0, fail: 0, gaveUp: false }, { time: 120, play: 0, fail: 0, gaveUp: false }],
            name: "Anna",
            studentId: "5",
            date: 1,
        },
        {
            result: [{ time: 50, play: 0, fail: 0, gaveUp: false }, { time: 200, play: 0, fail: 0, gaveUp: false }],
            name: "Jani",
            studentId: "6",
            date: 1,
        },
        {
            result: [{ time: 30, play: 0, fail: 0, gaveUp: false }, { time: 110, play: 0, fail: 0, gaveUp: false }],
            name: "Zoli",
            studentId: "7",
            date: 1,
        },
        {
            result: [{ time: 40, play: 0, fail: 0, gaveUp: false }, { time: 90, play: 0, fail: 0, gaveUp: false }],
            name: "Sanyi",
            studentId: "8",
            date: 1,
        },
        {
            result: [{ time: 30, play: 0, fail: 0, gaveUp: false }, { time: 50, play: 0, fail: 0, gaveUp: false }],
            name: "Luca",
            studentId: "9",
            date: 1,
        },
        {
            result: [{ time: 60, play: 0, fail: 0, gaveUp: false }, { time: 30, play: 0, fail: 0, gaveUp: false }],
            name: "Bogi",
            studentId: "10",
            date: 1,
        },
    ],
    plan: {
        tasks: [{ type: "rhytSorting" }, { type: "solfaName" }] as ITask[],
        _id: "5e4d94c74f8087001e343133",
        accepted: true,
        shared: true,
        sharable: true,
        playable: true,
        name: {
            en: "Exercise",
            hu: "Gyakorlat",
        },
        scores: [],
        description: {},
        experience: {positions: [], enabled: false},
        meta: {
            rhythm: {},
            pitch: {},
            teaching: {},
            opus: {},
        },
        user: "",
        created: 1,
    } as IPlan,
};
